
(function(){
    angular.module('tmx-app').factory('DeviceService', ['tmxResource','$q','tmxUtility','UsersService', function(tmxResource,$q,tmxUtility,UsersService){


        var Devices = tmxResource("Device");

        Devices.status = [
            { HiddenValue: "active",
                VisibleValue: "Active"
            },
            { HiddenValue: "inactive",
                VisibleValue: "Inactive"
            },
            { HiddenValue: "pending",
                VisibleValue: "Pending"
            }
        ];

        Devices.gridColumn = [
                
            {
                field: "DeviceName",
                title: "DeviceName",
                type: "text",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : DeviceManagementCtrl.isFiltered('DeviceName')}\" >{{'DeviceName' | translate}} <i class='fa fa-filter' ng-if='DeviceManagementCtrl.isFiltered(\"DeviceName\")' ></i></span>"
            },
            {
                field: "UserId",
                title: "User",
                type: "select",
                data: Devices.users,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : DeviceManagementCtrl.isFiltered('UserId')}\" >{{'User' | translate}}  <i class='fa fa-filter' ng-if='DeviceManagementCtrl.isFiltered(\"UserId\")' ></i></span>"
            },
            {
                field: "PhoneNumber1",
                title: "Phone",
                type: "numeric",
                search: false,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : DeviceManagementCtrl.isFiltered('PhoneNumber1')}\" >{{'Phone' | translate}}  <i class='fa fa-filter' ng-if='DeviceManagementCtrl.isFiltered(\"PhoneNumber1\")' ></i></span>"

            },
            {
                field: "DeviceModelName",
                title: "Manufacturer",
                type: "text",
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : DeviceManagementCtrl.isFiltered('DeviceModelName')}\" >{{'Manufacturer' | translate}}  <i class='fa fa-filter' ng-if='DeviceManagementCtrl.isFiltered(\"DeviceModelName\")' ></i></span>",
                fields: ["DeviceMake","DeviceModelName"],
                isComposite: true
            },
                    
            {
                field: "Status",
                title: "Status",
                type: "select",
                data: Devices.status,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : DeviceManagementCtrl.isFiltered('Status')}\" >{{'Status' | translate}}  <i class='fa fa-filter' ng-if='DeviceManagementCtrl.isFiltered(\"Status\")' ></i></span>"

            }

                    
        ];


        Devices.getAllDevices = function() {

            return Devices.all();
        };
  
        Devices.GetActiveUnassignedDeviceLov = function (userId) {
            let data;
            if(angular.isDefined(userId) && userId!=null)
                data = {
                    UserId:userId,
                    Parameter:"USER"
                };
            else
                data = {
                    Parameter:"USER"
                };
            return Devices.getByAction("GetActiveUnassignedDeviceLov",true,"put",data);
        };

        Devices.deleteById = function(id) {
            var deferred = $q.defer();
            Devices.getById(id).then(function(result) {
                deferred.resolve(result.$remove());
            });
    // item.$remove();
            return deferred.promise;
        };

        UsersService.ActiveLov().then(function(result){
            Devices.gridColumn[1].data = result.data;
            Devices.recievedLov=true;
        });

        var lovs = [{key: "lov",
            promise: UsersService.ActiveLov()
        }];

        tmxUtility.getAsynch($q,lovs).then(function(result){
            Devices.gridColumn[1].data = result.lov.data;
        });


        Devices.columns = angular.copy(Devices.gridColumn);
        Devices.columns.push(

                           
            {command :[
                {
                    name: "Delete",
                    text: "",
                    template: "<md-button ng-disabled='DeviceManagementCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickDelete(dataItem)'> <md-icon md-svg-src='assets/images/garbage12.svg' /></md-button>"
                },
                                 
                {
                    name: "Edit",
                    text: "",
                    template: "<md-button ng-disabled='DeviceManagementCtrl.isStatusActive(dataItem)' aria-label='del' class='tmxMin' ng-click='DeviceManagementCtrl.clickEdit(dataItem)'> <md-icon md-svg-src='assets/images/edit45.svg' /></md-button>"
                                      
                }
            ]}
        );

        return Devices;

    }]);
})();